export const errorCodes = Object.freeze({
  http: {
    ERROR_301: 301,
    ERROR_400: 400,
    ERROR_401: 401,
    ERROR_403: 403,
    ERROR_404: 404,
    ERROR_408: 408,
    ERROR_500: 500,
    ERROR_502: 502,
    ERROR_504: 504,
    ERROR_UNAUTHORIZED: 'unauthorized',
    TABLEAU_ERROR_404: 'Tableau404',
  },
  userServiceErrorCodes: {
    mfa: {
      VERIFYMFATOKENLOGIN_USER_NOT_AUTHORIZED: 'VERIFYMFATOKENLOGIN_USER_NOT_AUTHORIZED',
    },
  },
})
